import React, { useMemo } from 'react'
import classNames from 'classnames'
import styles from './post.module.scss'
import { Attachments } from './attachments'
import { ControllerPlayer, TaskPost } from '../../types'
import { PlaylistVideo } from '../../../../../services/studio/src/components/playlist/playlist-video'
import { TaskPostVideoOrientation } from '../../../../../services/studio/src/types/task.types'

interface Props {
  content: TaskPost['content']
  attachments: TaskPost['attachments']
  children: React.ReactNode
  onEventDispatch?: ControllerPlayer['onEventDispatch']
  video?: TaskPost['video']
}

export const Post: React.FC<Props> = ({
  children,
  content,
  attachments,
  onEventDispatch,
  video
}) => {
  const hasVideo = useMemo(() => video && video.length > 0, [video])

  const landscapeVideos = useMemo(() => {
    return video
      ?.filter((v) => v?.orientation === TaskPostVideoOrientation.LANDSCAPE)
      ?.map((v) => (
        <PlaylistVideo
          key={v?.title}
          title={v?.title}
          video={v?.video}
          thumbnail={v?.thumbnail}
          duration={v?.duration}
          orientation={TaskPostVideoOrientation.PORTRAIT}
        />
      ))
  }, [video])

  return (
    <div
      className={classNames(styles.container, {
        [styles.withVideo]: hasVideo
      })}
    >
      {children}

      {landscapeVideos}

      <div
        className={classNames(styles.content, {
          [styles.withVideo]: hasVideo
        })}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: content }}
      />

      <Attachments
        attachments={attachments}
        onEventDispatch={onEventDispatch}
      />
    </div>
  )
}
